import { builtinData } from '../../data';

import { find, pick } from 'lodash';

const { ageGroups, contests } = builtinData;

const defaultAgeGroupBundles = ['IWF Senior'];
const defaultAgeGroups = ageGroups.filter(({ bundle }) =>
  defaultAgeGroupBundles.includes(bundle),
);
const defaultContests = contests.filter(({ ageGroup }) =>
  find(defaultAgeGroups, { uuid: ageGroup }),
);

const defaultState = {
  ...pick(builtinData, 'genders', 'lifts', 'bodyweightCategories', 'ageGroups'),
  contests: defaultContests,
  events: [
    {
      singleton: 'singleton',
      title: 'UNNAMED EVENT',
      location: '<LOCATION>',
      duration: '<DURATION>',
      mode: 'default',
    },
  ],
};

export default defaultState;



// WEBPACK FOOTER //
// ./src/pages/Home/defaultState.js